import { Info } from "lucide-react";

/**
 * Informational note (Info icon + text) rendered above a flow component's body.
 * Purely presentational — the caller owns the wording and the visibility rule.
 */
export function InfoNote({ text }: { text: string }) {
  return (
    <div className="flex items-start gap-2 rounded-md border bg-muted/50 px-3 py-2 text-sm text-muted-foreground">
      <Info className="h-4 w-4 mt-0.5 shrink-0" />
      <span>{text}</span>
    </div>
  );
}
